export default "__VITE_ASSET__c15fd809__"